import { Select, type SelectProps } from "antd"
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../store/slices/infoUserSlice";
interface DebounceSelectProps<ValueType = any> extends Omit<SelectProps<ValueType>, "options" | "children"> {
  debounceTimeout?: number
  disabled?: boolean
  options?: ValueType[] // cho phép truyền options từ ngoài vào nếu có
}

export function DebounceSelect<ValueType extends { key?: string; label: React.ReactNode; value: string | number } = any>({
  debounceTimeout = 800,
  disabled,
  options,
  ...props
}: DebounceSelectProps<ValueType>) {
  const { unitTemp } = useSelector(selectorInfoUser)
  return (
    <Select
      filterOption={false}
      // notFoundContent={fetching ? <Spin size="small" /> : null}
      disabled={unitTemp ? true : false}
      options={options}
      className="rs-select"

      {...props}
    />
  )
}
export function DebounceSelect_V2<ValueType extends { key?: string; label: React.ReactNode; value: string | number } = any>({
  debounceTimeout = 800,
  disabled,
  options,
  ...props
}: DebounceSelectProps<ValueType>) {
  return (
    <Select
      filterOption={false}
      // notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      className="rs-select"

      {...props}
    />
  )
}
